export default str => {
  const cleanString = str.replace(/(<([^>]+)>)/gi, '');
  return cleanString.split(' ').length;
};
